module.exports = __webpack_public_path__ + "static/media/page3-1.b6ee4848.png";